import { Component, OnInit, OnDestroy,} from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { EssencialService } from '../../services/essencial.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { buttons, mensajes } from '../../../../../assets/data/diccionario.js';
import { essencialModul } from '../../diccionarios/essencialModulo';
import { from, Subscription } from 'rxjs';

@Component({
  selector: 'app-mantener-grupo-vendedores-b2-c',
  templateUrl: './mantener-grupo-vendedores-b2-c.component.html',
  styleUrls: ['./mantener-grupo-vendedores-b2-c.component.css']
})

export class MantenerGrupoVendedoresB2CComponent implements OnInit {

  public DAT_TITULOS = essencialModul.titulos.relacionGrupoSubcanal;
  public DAT_AG_GRID = essencialModul.agGrid;
  public DAT_BTNCSS  = buttons;
  public MENS_STANDAR= mensajes;

  public titleModal  : string;
  public loading     : boolean = false;
  public isCreate    : boolean = true;

  public frameworkComponents: any;
  public columnDefs  : any[] = [];
  public rowData     : any[] = [];
  public gridApi     : any;
  public gridColumnApi: any;

  public comboCanal   : any[] = [];
  public comboSubCanal: any[] = [];

  public formulario = new FormGroup({
    idGrupoVendedor : new FormControl('', [Validators.required]),
    idSubCanal      : new FormControl('', [Validators.required]),
  });

  constructor(
    private essecialServices: EssencialService,
    private utilServices    : UtilsService,
    private dmaestroServices: DatosMaestrosService,
  ) { }

  ngOnInit(): void {
    this.inicializaCombos();
    this.listar();
    this.gridComponent();
  }

  gridComponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent, };
    this.columnDefs = [
      { filter: true, resizable: true, field: 'idGrupoVendedor'},
      { filter: true, resizable: true, field: 'nombreGrupoVendedor'},
      { filter: true, resizable: true, field: 'idSubCanal'},
      { filter: true, resizable: true, field: 'nombreSubCanal'},
      { cellRenderer: 'buttonRenderer', headerName: 'Eliminar',
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: 'Eliminar', classBtn: 'btn btn-danger', iconBtn: 'fa fa-trash'
        },
      }
    ];

  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  listar(){
    this.rowData =[];
    this.essecialServices.getAllRelacionGrupoSubcanal().subscribe((res) => {
      this.rowData = res;
    }, (err) => { 
      console.log(err.message); 
    });
  }

  nuevo() {
    this.isCreate   = true;
    this.titleModal = "Nuevo registro";
    this.formulario.reset();
    this.openModal();
  }

  eliminar({rowData}){
    this.loading = true;
    console.log('Eliminar => ', rowData);

    this.utilServices.confirmarSincronoPromesa({
        title : this.MENS_STANDAR.eliminar,
        text  : this.DAT_TITULOS.tituloEliminar,
        action: "Eliminar",
        funcion: this.essecialServices.eliminarRelacionGrupoSubcanal(rowData),
      })
      .then((_res: any) => {
        this.listar();
        this.closeModal();
      }).catch(() => { });
    
    this.loading = false;
  }

  saveForm() {
    let mensajeP = this.isCreate ? this.MENS_STANDAR.guardar : this.MENS_STANDAR.actualizar;
    let registro = this.formulario.getRawValue();  
    this.loading = true;

    this.utilServices.confirmarSincronoPromesa({
        title   : mensajeP,
        text    : this.DAT_TITULOS.titulo,
        action  : this.titleModal,
        funcion : this.essecialServices.crearRelacionGrupoSubcanal(registro),
      }).then(() => {
        this.listar();
        this.closeModal();
      }).catch(() => {});

      this.loading = false;
  }

  acciones(event) {
    console.log("evento del clic", event);
    if (event === 'regresar') return this.closeModal();
    if (this.formulario.invalid) return;
    this.saveForm();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }


  inicializaCombos(){
    this.loading  = true;
    this.comboCanal    = [];
    this.comboSubCanal = [];

    //Grupo Vendedor
    this.dmaestroServices.getAllGrupoVendedor().subscribe((response) => {
      if(response.length > 0){
        response.map(e => {
          e.dscaGrupoVendedor = e.idGrupoVendedor +" - "+e.dscaGrupoVendedor;
          return e;          
        });
        this.comboCanal = response;
        console.log(this.comboCanal);
      }else{
        this.utilServices.mensajeOKToast("No se encontraron registros", 3000);
      }
    }, (err) => { 
      console.log(err.err.message);
    });

    //Grupo tarifa canal - subcanal
    this.dmaestroServices.getAllGrupoTarifaCanal().subscribe((response) => {
      if(response.length > 0){
        this.comboSubCanal = response;
        console.log(this.comboSubCanal);
      }else{
        this.utilServices.mensajeOKToast("No se encontraron registros", 3000);
      }
    }, (err) => { 
      console.log(err.err.message);
    });

    this.loading = false;
  }

}
